import React from "react";
import {
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  InputLabel,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
}));

const ProductKeyForm = (props) => {
  const {
    handleChange,
    product,
    overriddenEndorment,
    overriddenStyle,
    productASOptions,
    isLoading,
    handleChangeProductASInput,
  } = props;

  const classes = useStyles();

  return (
    <form margin="dense" noValidate autoComplete="off" className={classes.form}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
              endAdornment: overriddenEndorment("size", product),
            }}
            size="small"
            variant="outlined"
            label="Size"
            name="size"
            value={product && product.size}
            onChange={handleChange}
            style={{
              background: overriddenStyle("size", product),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
              endAdornment: overriddenEndorment("items_per_case", product),
            }}
            size="small"
            variant="outlined"
            label="Items per Case"
            name="items_per_case"
            value={product && product.items_per_case}
            onChange={handleChange}
            style={{
              background: overriddenStyle("items_per_case", product),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputLabel shrink id="acceptableSubstitutionsLabel">
            Acceptable Substitutions
          </InputLabel>

          <Autocomplete
            fullWidth
            multiple
            size="small"
            name="acceptable_substitutions_detail"
            options={productASOptions}
            getOptionLabel={(option) =>
              `${option.name} (${option.upc}) - ${
                option.item_code.item_code || ""
              }`
            }
            renderInput={(params) => (
              <TextField {...params} size="small" variant="standard" />
            )}
            isOptionEqualToValue={(option, value) => option.upc === value.upc}
            renderOption={(props, option) => (
              <li {...props}>
                {`${option.name} | (${option.upc}) #${
                  option.item_code.item_code || ""
                }# Stock: ${option.stock_level || 0} `}
              </li>
            )}
            loading={isLoading}
            /* noOptionsText={
              productInputValue.length < 3
                ? "Please enter at least 3 characters to search"
                : "No options"
            } */
            onInputChange={handleChangeProductASInput}
            onChange={(e, v) =>
              handleChange(
                {
                  target: {
                    checked: false,
                    name: `acceptable_substitutions_detail`,
                    value: product.acceptable_substitutions_detail,
                  },
                },
                v,
              )
            }
            value={product && product.acceptable_substitutions_detail}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <FormControlLabel
            value="start"
            control={
              <Checkbox
                name="tax_default"
                value={product && product.tax_default}
                checked={product && product.tax_default}
                onChange={handleChange}
                color="primary"
              />
            }
            label="Tax Default"
            labelPlacement="end"
          />
          <FormHelperText id="taxDefaultHelperText">
            If checked, when this item appears in an order it's Taxable field
            will initially be checked as well.
          </FormHelperText>
        </Grid>
        <Grid item xs={12} sm={12}>
          <FormControlLabel
            value="start"
            control={
              <Checkbox
                name="active"
                value={product && product.active}
                checked={product && product.active}
                onChange={handleChange}
                color="primary"
              />
            }
            label="Active"
            labelPlacement="end"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
            }}
            size="small"
            variant="outlined"
            label="Qb Item # Mapping "
            name="qb_mapping"
            value={product && product.qb_mapping}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
            }}
            size="small"
            variant="outlined"
            label="Qb Site Mapping "
            name="qb_site_mapping"
            value={product && product.qb_site_mapping}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <FormControlLabel
            value="start"
            control={
              <Checkbox
                name="display_units_per_case_on_invoice"
                value={product && product.display_units_per_case_on_invoice}
                checked={product && product.display_units_per_case_on_invoice}
                onChange={handleChange}
                color="primary"
              />
            }
            label="Display Units per Case on Invoice"
            labelPlacement="end"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <FormControlLabel
            value="start"
            control={
              <Checkbox
                name="lot_tracked"
                value={product && product.lot_tracked}
                checked={product && product.lot_tracked}
                onChange={handleChange}
                color="primary"
              />
            }
            label="Lot Tracked"
            labelPlacement="end"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: { min: 0 },
            }}
            size="small"
            variant="outlined"
            label="Par Stock"
            name="par_stock"
            value={product && product.par_stock}
            type="number"
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <FormControlLabel
            value="start"
            control={
              <Checkbox
                name="item_searchable"
                value={product && product.item_searchable}
                checked={product && product.item_searchable}
                onChange={handleChange}
                color="primary"
              />
            }
            label="Item Searchable"
            labelPlacement="end"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: { min: 0 },
            }}
            size="small"
            variant="outlined"
            label="Reorder Quantity"
            name="reorder_quantity"
            value={product && product.reorder_quantity}
            type="number"
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default ProductKeyForm;
